import { combineReducers } from 'redux'
import createAvailabilityReducer, { createAvailabilityActions } from '@store/slices/calendar/createAvailability'
import editAvailabilityReducer, { editAvailabilityActions } from '@store/slices/calendar/editAvailability'
import oneAvailabilityReducer, { oneAvailabilityActions } from '@store/slices/calendar/oneAvailability'
import availabilityValidateLinkReducer, {
    availabilityValidateLinkActions
} from '@store/slices/calendar/availabilityValidateLink'
import syncReducer, { syncActions } from '@store/slices/calendar/sync'
import syncAuthenticateURLReducer, { syncAuthenticateURLActions } from '@store/slices/calendar/syncAuthenticateURL'
import getConnectedCalendarReducer, { getConnectedCalendarActions } from '@store/slices/calendar/getConnectedCalendar'
import removeSyncReducer, { removeSyncActions } from '@store/slices/calendar/removeSync'

export const calendarReducers = combineReducers({
    createAvailability: createAvailabilityReducer,
    editAvailability: editAvailabilityReducer,
    oneAvailability: oneAvailabilityReducer,
    availabilityValidateLink: availabilityValidateLinkReducer,
    sync: syncReducer,
    syncAuthenticateURL: syncAuthenticateURLReducer,
    getConnectedCalendar: getConnectedCalendarReducer,
    removeSync: removeSyncReducer
})

export const calendarActions = {
    createAvailability: createAvailabilityActions,
    editAvailability: editAvailabilityActions,
    oneAvailability: oneAvailabilityActions,
    availabilityValidateLink: availabilityValidateLinkActions,
    sync: syncActions,
    syncAuthenticateURL: syncAuthenticateURLActions,
    getConnectedCalendar: getConnectedCalendarActions,
    removeSync: removeSyncActions
}
